import { Component, NgZone } from '@angular/core';
import { from, Observable, take, tap } from 'rxjs';

import { BaseAlertsOutletComponent } from './base-alerts-outlet.component';
import { AlertsService } from './alerts.service';
import { IAlert, IAlertAction } from './alerts.interfaces';

@Component({
  selector: 'angular-alerts-outlet',
  templateUrl: './angular-alerts-outlet.component.html',
  styleUrls: ['./angular-alerts-outlet.component.scss']
})
export class AngularAlertsOutletComponent extends BaseAlertsOutletComponent {
  alerts: IAlert[] = [];

  constructor(
    service: AlertsService,
    private readonly zone: NgZone,
  ) {
    super(service);
  }

  async dismissAllAlerts(): Promise<void> {
    this.alerts = [];
    return Promise.resolve();
  }

  showAlert(alert: IAlert): void {
    from(this.prepareAlert(alert))
      .pipe(
        take(1),
        tap((alert) => {
          this.zone.run(() => {
            this.alerts.push(alert);

            setTimeout(() => {
              this.close(alert.id);
            }, alert.duration || this.service.alertDuration);
          });
        }),
      )
      .subscribe();
  }

  close(id: string): void {
    this.alerts = this.alerts.filter(alert => alert.id !== id);
  }

  handleAction(action: IAlertAction, alertId: string): void {
    action.action();
    // Optionally close the alert after action is performed
    this.close(alertId);
  }

  private async prepareAlert(alert: IAlert): Promise<IAlert> {
    if (alert.actions) {
      alert.actions.push({
        label: '✖',
        action: () => this.close(alert.id),
      });
    } else {
      alert.actions = [{
        label: '✖',
        action: () => this.close(alert.id),
      }];
    }

    return new Promise((resolve, reject) => resolve(alert));
  }
}
